import discountPopupSlice from "../slices/discountPopupSlice";

export const discountPopupReducers = {
  discountPopup: discountPopupSlice,
};
